import styled from "styled-components";
import {Form, InputNumber, Select} from "antd";

export const ProductFormItem = styled(Form.Item)`
    margin-bottom: 0;
`;

export const TitleLabel = styled.label`
    font-size: 18px !important;
`;

export const InputNumberField = styled(InputNumber)`
    width: 100%;
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const FileInput = styled.input`
    margin-bottom: 20px;
`;

export const DateRangePickerContainer = styled.div`
   margin-top: 16px;
   margin-bottom:16px;
`